import { ref, watch } from '@vue/composition-api'

export default function useElementSize(element) {
  const width = ref(0)
  const height = ref(0)

  let observer = null

  function disconnect() {
    if (observer !== null) {
      observer.disconnect()
      observer = null
    }
  }

  function connect(element) {
    disconnect()
    observer = new ResizeObserver((entries) => {
      if(entries[0]) {
        const rect = entries[0].contentRect
        if (rect) {
          width.value = rect.width
          height.value = rect.height
        }
      }
    })

    observer.observe(element)
  }

  watch(element, (el) => el ? connect(el) : disconnect())

  return {
    width,
    height
  }
}
